"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bind_decorator_1 = __importDefault(require("bind-decorator"));
const classnames_1 = __importDefault(require("classnames"));
const debounce_1 = require("debounce");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const NativeSelect_1 = __importDefault(require("../../../common/js/atoms/NativeSelect"));
const ButtonSize_1 = __importDefault(require("../../../common/js/enums/ButtonSize"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const translation_1 = require("../../../common/js/helper/translation");
const Input_1 = __importDefault(require("../../atoms/Input"));
const TermsAndConditions_1 = __importDefault(require("../../atoms/TermsAndConditions"));
const Paths = __importStar(require("../../constants/Paths"));
const error_1 = require("../../helper/error");
const history_1 = require("../../helper/history");
const registration_1 = require("../../helper/registration");
const AccountStore_1 = __importDefault(require("../../stores/AccountStore"));
const Countries_1 = __importDefault(require("../../stores/Countries"));
const MassiveCompany_1 = __importDefault(require("../../stores/MassiveCompany"));
const RegistrationStore_1 = __importDefault(require("../../stores/RegistrationStore"));
class RegistrationCompanyInformation extends react_1.default.Component {
    debounceValidateTaxId = (0, debounce_1.debounce)(this.validateTaxId, 500);
    taxIdRef = react_1.default.createRef();
    validating = false;
    submitting = false;
    constructor(props) {
        super(props);
        (0, mobx_1.makeObservable)(this, {
            validating: mobx_1.observable,
            submitting: mobx_1.observable,
            isSubmitting: mobx_1.computed,
            requiresTaxId: mobx_1.computed,
        });
    }
    get isSubmitting() {
        return this.submitting;
    }
    get requiresTaxId() {
        return (Countries_1.default.getCountryByCode(RegistrationStore_1.default.companyData.countryCode)?.extensions?.zkpCountryData
            ?.requiresTaxId ?? false);
    }
    componentDidMount() {
        this.debounceValidateTaxId(false);
    }
    render() {
        return (react_1.default.createElement("section", { className: "znd-registration-company-information" },
            react_1.default.createElement("h1", { className: (0, classnames_1.default)('znd-registration-company-information__title', 't-headline-2') }, (0, translation_1.t)('registration.company_information.title')),
            react_1.default.createElement("form", { className: "znd-registration-company-information__container", onSubmit: this.submit },
                react_1.default.createElement("h2", { className: "t-subhead-1" }, (0, translation_1.t)('registration.company_information.sub_title')),
                react_1.default.createElement("h3", { className: (0, classnames_1.default)('znd-registration-company-information__input-header', 't-body-small') }, (0, translation_1.t)('registration.company_information.company.title')),
                react_1.default.createElement(Input_1.default, { key: "company", type: "text", className: "form-control", required: true, value: RegistrationStore_1.default.companyData.company, placeholder: (0, translation_1.t)('registration.company_information.company.placeholder'), onChange: (event) => {
                        RegistrationStore_1.default.setCompanyData({ company: event.target.value });
                    }, onBlur: (event) => {
                        RegistrationStore_1.default.setCompanyData({ company: event.target.value.trim() });
                    }, limitAllowedCharset: true }),
                react_1.default.createElement("h3", { className: (0, classnames_1.default)('znd-registration-company-information__input-header', 't-body-small') },
                    (0, translation_1.t)('registration.company_information.tax_id.title'),
                    this.requiresTaxId ? (react_1.default.createElement(react_1.default.Fragment, null,
                        ' ',
                        react_1.default.createElement("span", { className: "required" }, "*"))) : null),
                react_1.default.createElement("input", { key: "taxId", type: "text", className: "form-control znd-registration-company-information__tax-input", required: this.requiresTaxId, ref: this.taxIdRef, value: RegistrationStore_1.default.companyData.taxId, placeholder: (0, translation_1.t)('registration.company_information.tax_id.placeholder'), onChange: (event) => {
                        this.validating = true;
                        RegistrationStore_1.default.setCompanyData({ taxId: event.target.value });
                        this.debounceValidateTaxId(true);
                    }, onBlur: (event) => {
                        RegistrationStore_1.default.setCompanyData({ taxId: event.target.value.trim() });
                    } }),
                react_1.default.createElement("h2", { className: "t-subhead-1" }, (0, translation_1.t)('registration.company_information.address.title')),
                react_1.default.createElement("h3", { className: (0, classnames_1.default)('znd-registration-company-information__input-header', 't-body-small') }, (0, translation_1.t)('registration.company_information.address.sub_title')),
                react_1.default.createElement(Input_1.default, { key: "address", type: "text", className: "form-control", required: true, value: RegistrationStore_1.default.companyData.address, placeholder: (0, translation_1.t)('registration.company_information.address.placeholder'), onChange: (event) => {
                        RegistrationStore_1.default.setCompanyData({ address: event.target.value });
                    }, onBlur: (event) => {
                        RegistrationStore_1.default.setCompanyData({ address: event.target.value.trim() });
                    }, limitAllowedCharset: true }),
                react_1.default.createElement("div", { className: "znd-registration-company-information__country-container" },
                    react_1.default.createElement("div", { className: "znd-registration-company-information__input-container" },
                        react_1.default.createElement("h3", { className: (0, classnames_1.default)('znd-registration-company-information__select-header', 't-body-small') }, (0, translation_1.t)('registration.company_information.country.title')),
                        react_1.default.createElement(NativeSelect_1.default, { className: "znd-registration-company-information__country-select", key: "countrySelect", placeholder: (0, translation_1.t)('registration.company_information.country.placeholder'), noOptionPreselected: true, required: true, options: Countries_1.default.registrationCountries, disabled: true, value: RegistrationStore_1.default.companyData.countryCode ?? '', onChange: () => void 0 }))),
                react_1.default.createElement("div", { className: "znd-registration-company-information__zip-container" },
                    react_1.default.createElement("div", { className: "znd-registration-company-information__input-container" },
                        react_1.default.createElement("h3", { className: (0, classnames_1.default)('znd-registration-company-information__input-header', 't-body-small') }, (0, translation_1.t)('registration.company_information.zip_code.title')),
                        react_1.default.createElement(Input_1.default, { key: "zipCode", type: "text", className: "form-control", required: true, value: RegistrationStore_1.default.companyData.zip, placeholder: (0, translation_1.t)('registration.company_information.zip_code.placeholder'), onChange: (event) => {
                                RegistrationStore_1.default.setCompanyData({ zip: event.target.value });
                            }, onBlur: (event) => {
                                RegistrationStore_1.default.setCompanyData({ zip: event.target.value.trim() });
                            }, limitAllowedCharset: true })),
                    react_1.default.createElement("div", { className: "znd-registration-company-information__input-container" },
                        react_1.default.createElement("h3", { className: (0, classnames_1.default)('znd-registration-company-information__input-header', 't-body-small') }, (0, translation_1.t)('registration.company_information.city.title')),
                        react_1.default.createElement(Input_1.default, { key: "city", type: "text", className: "form-control znd-registration-company-information__city-input", required: true, value: RegistrationStore_1.default.companyData.city, placeholder: (0, translation_1.t)('registration.company_information.city.placeholder'), onChange: (event) => {
                                RegistrationStore_1.default.setCompanyData({ city: event.target.value });
                            }, onBlur: (event) => {
                                RegistrationStore_1.default.setCompanyData({ city: event.target.value.trim() });
                            }, limitAllowedCharset: true }))),
                react_1.default.createElement("div", { className: "znd-registration-company-information__divider" }),
                react_1.default.createElement(TermsAndConditions_1.default, { checked: RegistrationStore_1.default.generalData.acceptedTermsAndConditions, onChange: (event) => {
                        RegistrationStore_1.default.setGeneralData({ acceptedTermsAndConditions: event.target.checked });
                    } }),
                react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.primary, size: ButtonSize_1.default.default, text: (0, translation_1.t)('registration.company_information.complete'), className: 'znd-registration-company-information__button', type: "submit", loading: this.isSubmitting, disabled: this.validating || this.isSubmitting }))));
    }
    validateTaxId(report) {
        if (!RegistrationStore_1.default.companyData.taxId.trim()) {
            return;
        }
        MassiveCompany_1.default.validateTaxId(RegistrationStore_1.default.companyData.countryCode, RegistrationStore_1.default.companyData.taxId.trim())
            .then(() => {
            this.taxIdRef.current?.setCustomValidity('');
        })
            .catch((response) => (0, error_1.handleErrorResponse)(response)
            .then(registration_1.handleVatCheckErrorResponse)
            .then((code) => {
            this.taxIdRef.current?.setCustomValidity((0, translation_1.t)(`registration.error.${code}`));
        }))
            .finally(() => {
            if (report) {
                this.taxIdRef.current?.reportValidity();
            }
            this.validating = false;
        });
    }
    submit(event) {
        event.preventDefault();
        this.submitting = true;
        AccountStore_1.default.registerAccount(RegistrationStore_1.default.generalData, RegistrationStore_1.default.personalData, RegistrationStore_1.default.companyData)
            .then(() => {
            RegistrationStore_1.default.resetRegistrationData();
            (0, history_1.pushHistory)(this.props.history, Paths.PATH_REGISTRATION_SUCCESS);
        })
            .catch((response) => (0, error_1.handleErrorResponse)(response).then(registration_1.handleRegistrationErrorResponse))
            .finally(() => {
            this.submitting = false;
        });
    }
}
__decorate([
    bind_decorator_1.default
], RegistrationCompanyInformation.prototype, "validateTaxId", null);
__decorate([
    bind_decorator_1.default
], RegistrationCompanyInformation.prototype, "submit", null);
exports.default = (0, react_router_dom_1.withRouter)((0, mobx_react_1.observer)(RegistrationCompanyInformation));
